import { motion } from "framer-motion";
import { HeartHandshake, Sparkles, Wrench } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { IMG } from "../config";

const PILLARS = [
  {
    id: "kesejahteraan",
    icon: HeartHandshake,
    num: "01",
    tag: "Sosial & Ekonomi",
    title: "Kesejahteraan Tanpa Batas",
    desc: "Memastikan tidak ada warga yang tertinggal. Dari penyaluran bantuan tepat sasaran untuk warga prasejahtera, advokasi kesehatan lansia, hingga jaminan gizi dan pendidikan bagi anak-anak Cianjay.",
    img: IMG.bantuan,
    alt: "Penyaluran bantuan desa kepada warga lansia",
  },
  {
    id: "ekspresi",
    icon: Sparkles,
    num: "02",
    tag: "Pemuda & Komunitas",
    title: "Ruang Ekspresi Tanpa Diskriminasi",
    desc: "Pemuda kreatif adalah nyawa desa. Baik itu komunitas mancing mania, perkumpulan Otaku lokal, hingga fasilitasi gigs untuk teman-teman Wota JKT48 — semua pemuda punya ruang aman dan dukungan penuh untuk berekspresi positif di Cianjay.",
    img: IMG.wota,
    alt: "Pak Kades bersama pemuda dan lightstick Wota JKT48 di balai desa",
  },
  {
    id: "infrastruktur",
    icon: Wrench,
    num: "03",
    tag: "Fasilitas & Lingkungan",
    title: "Infrastruktur Tanggap Warga",
    desc: "Penataan fasilitas umum yang ramah anak, penerangan jalan dusun yang maksimal, dan respons cepat terhadap perbaikan infrastruktur vital penyokong ekonomi desa.",
    img: IMG.mancing,
    alt: "Pak Kades berdiskusi dengan komunitas mancing di kolam warga",
  },
];

export const Pillars = () => (
  <section id="kerja-nyata" data-testid="pillars-section" className="py-24 sm:py-32 bg-surfacewarm border-y border-line transition-colors duration-500">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <SectionHeading
        bab="Bab 03"
        label="Aksi Nyata & Ruang Komunitas"
        title="Kerja Nyata untuk Cianjay"
        sub="Bergerak bersama memastikan setiap warga mendapatkan hak dan ruangnya di desa ini."
        testid="pillars"
      />

      <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
        {PILLARS.map((p, i) => (
          <motion.article
            key={p.id}
            data-testid={`pillar-card-${p.id}`}
            initial={{ opacity: 0, y: 44 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.14, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -8 }}
            className="group relative flex flex-col overflow-hidden rounded-3xl border border-line bg-surface shadow-[0_10px_35px_rgba(30,58,43,0.07)] transition-shadow hover:shadow-[0_28px_60px_rgba(30,58,43,0.16)]"
          >
            <div className="relative h-52 overflow-hidden">
              <img
                src={p.img}
                alt={p.alt}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-forest/50 to-transparent" />
              <span className="absolute top-4 left-4 rounded-full bg-bg/90 backdrop-blur px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-forest">
                {p.tag}
              </span>
              <span className="absolute bottom-3 right-4 font-serif italic text-4xl text-white/85">{p.num}</span>
            </div>
            <div className="flex flex-1 flex-col p-6 sm:p-7">
              <span className="grid place-items-center w-11 h-11 rounded-2xl bg-badge text-terra mb-5">
                <p.icon size={20} />
              </span>
              <h3 className="font-serif text-xl sm:text-2xl font-semibold leading-tight">{p.title}</h3>
              <p className="mt-3.5 text-sm leading-relaxed text-soft">{p.desc}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
